import React from 'react'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import SecondaryLargeNavItem from './SecondaryLargeNavItem'

const styles = (theme) => ({
  root: {
    display: 'inline-block',
    margin: 'auto',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
})

const SecondaryLargeNav = ({ classes, routes, ...props }) => (
  <div className={classes.root} {...props}>
    {routes.secondary.map((routeProps, i) => (
      <SecondaryLargeNavItem
        key={`secondaryLargeNavItem${i}`}
        {...routeProps}
      />
    ))}
  </div>
)

SecondaryLargeNav.propTypes = {
  classes: PropTypes.object.isRequired,
  routes: PropTypes.shape({
    main: PropTypes.arrayOf(PropTypes.object).isRequired,
    secondary: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
}

export default withStyles(styles)(SecondaryLargeNav)



// WEBPACK FOOTER //
// ./src/components/Navigation/SecondaryLargeNav.js